import { CreateNpaReportReduxState, NpaReportReducerDispatch, NpaReportReduxTypes } from "./types"

const CREATE_NPA_REPORT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateNpaReportReducer = (state: CreateNpaReportReduxState = CREATE_NPA_REPORT_INIT_STATE, action: NpaReportReducerDispatch) => {
    switch (action.type) {
        case NpaReportReduxTypes.NPA_REPORT: {
            return {
                ...state,
                loading: true
            }

        }
        case NpaReportReduxTypes.NPA_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case NpaReportReduxTypes.NPA_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return {...state};
    }
}

export {CreateNpaReportReducer}